export default function logger(message) {
    if (!isPRODUCTION) {
        // eslint-disable-next-line no-console
        console.log(message);
    }
}
